import { render, staticRenderFns } from "./InspectorTeamMembers.vue?vue&type=template&id=8d7be9a6&"
import script from "./InspectorTeamMembers.vue?vue&type=script&lang=js&"
export * from "./InspectorTeamMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports